import { render, staticRenderFns } from "./used-goods-list.vue?vue&type=template&id=21873d93&scoped=true"
import script from "./used-goods-list.vue?vue&type=script&lang=js"
export * from "./used-goods-list.vue?vue&type=script&lang=js"
import style0 from "./used-goods-list.vue?vue&type=style&index=0&id=21873d93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21873d93",
  null
  
)

export default component.exports